import { useMemo, useState } from 'react';
import { Copy, Trash2, ChevronDown } from 'lucide-react';
import clsx from 'clsx';
import { useDebugLogStore } from '../../stores/debug-log-store';
import { Button } from '../ui/Button';

function fmtTs(ts: number) {
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return String(ts);
  }
}

export function DebugLogPanel() {
  const entries = useDebugLogStore((s) => s.entries);
  const clear = useDebugLogStore((s) => s.clear);
  const [open, setOpen] = useState(false);

  const text = useMemo(() => {
    const rows = entries.map((e) => ({
      ts: fmtTs(e.ts),
      area: e.area,
      event: e.event,
      data: e.data ?? {},
    }));
    return JSON.stringify(rows, null, 2);
  }, [entries]);

  return (
    <div className="rounded-md border border-surface-lighter bg-surface p-3">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between"
      >
        <div className="text-xs font-semibold text-text">Debug log</div>
        <ChevronDown size={16} className={clsx('text-text-muted transition-transform', open && 'rotate-180')} />
      </button>

      <div className="mt-1 text-[10px] text-text-muted">
        Stored locally (localStorage). Use this to paste logs into chat.
      </div>

      {open && (
        <>
          <div className="mt-3 flex items-center justify-end gap-2">
            <Button
              variant="secondary"
              size="sm"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(text);
                } catch {
                  // ignore
                }
              }}
            >
              <Copy size={14} />
              <span className="ml-1.5">Copy</span>
            </Button>
            <Button variant="secondary" size="sm" onClick={clear}>
              <Trash2 size={14} />
              <span className="ml-1.5">Clear</span>
            </Button>
          </div>

          <pre className="mt-3 max-h-56 overflow-auto rounded bg-surface-light border border-surface-lighter p-3 text-[11px] text-text whitespace-pre-wrap break-words">
            {text || '[]'}
          </pre>
        </>
      )}
    </div>
  );
}

